import { useLayoutEffect, useRef } from 'react';

let freezeLockCount = 0;
let freezeSnapshot = null;

const lockBackground = () => {
  if (typeof window === 'undefined') {
    return;
  }

  freezeLockCount += 1;

  if (freezeLockCount > 1) {
    return;
  }

  const html = document.documentElement;
  const body = document.body;
  const lockedScrollY = window.scrollY || window.pageYOffset || 0;
  const scrollbarWidth = window.innerWidth - html.clientWidth;

  freezeSnapshot = {
    lockedScrollY,
    previousBehavior: html.style.scrollBehavior,
    htmlFreezeBg: html.getAttribute('data-freeze-bg'),
    htmlFreezeBgY: html.getAttribute('data-freeze-bg-y'),
    bodyStyles: {
      overflow: body.style.overflow,
      position: body.style.position,
      top: body.style.top,
      width: body.style.width,
      paddingRight: body.style.paddingRight,
    },
  };

  html.setAttribute('data-freeze-bg', '1');
  html.setAttribute('data-freeze-bg-y', String(lockedScrollY));

  body.style.paddingRight = `${scrollbarWidth}px`;
  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${lockedScrollY}px`;
  body.style.width = '100%';
};

const unlockBackground = () => {
  if (typeof window === 'undefined' || freezeLockCount === 0) {
    return;
  }

  freezeLockCount -= 1;

  if (freezeLockCount > 0 || !freezeSnapshot) {
    return;
  }

  const html = document.documentElement;
  const body = document.body;
  const {
    lockedScrollY,
    previousBehavior,
    htmlFreezeBg,
    htmlFreezeBgY,
    bodyStyles,
  } = freezeSnapshot;

  body.style.overflow = bodyStyles.overflow;
  body.style.position = bodyStyles.position;
  body.style.top = bodyStyles.top;
  body.style.width = bodyStyles.width;
  body.style.paddingRight = bodyStyles.paddingRight;

  html.style.scrollBehavior = 'auto';
  window.scrollTo(0, lockedScrollY);
  html.style.scrollBehavior = previousBehavior;

  if (htmlFreezeBg === null) {
    html.removeAttribute('data-freeze-bg');
  } else {
    html.setAttribute('data-freeze-bg', htmlFreezeBg);
  }

  if (htmlFreezeBgY === null) {
    html.removeAttribute('data-freeze-bg-y');
  } else {
    html.setAttribute('data-freeze-bg-y', htmlFreezeBgY);
  }

  freezeSnapshot = null;
};

export const useFreezeBackground = (active, options = {}) => {
  const { unlockDelayMs = 0 } = options;
  const unlockTimerRef = useRef(0);

  useLayoutEffect(() => {
    if (!active) {
      return undefined;
    }

    if (unlockTimerRef.current) {
      window.clearTimeout(unlockTimerRef.current);
      unlockTimerRef.current = 0;
    }

    lockBackground();

    return () => {
      if (unlockDelayMs > 0 && typeof window !== 'undefined') {
        unlockTimerRef.current = window.setTimeout(() => {
          unlockBackground();
          unlockTimerRef.current = 0;
        }, unlockDelayMs);
        return;
      }

      unlockBackground();
    };
  }, [active, unlockDelayMs]);
};
